export enum SocialNetworkContentType {
  POST = 'POST',
  VIDEO = 'VIDEO',
  COLLABORATION_GROUP = 'COLLABORATION_GROUP',
  HUB = 'HUB',
  CLINICAL_CASE = 'CLINICAL_CASE',
  CLINICAL_TRIAL = 'CLINICAL_TRIAL',
  EVENT = 'EVENT',
}
